export const advertiserLocationFromService = (location) => ({
    id: location.id,
    ...("address" in location && { address: location.address }),
    ...("city" in location && { city: location.city }),
    ...("state" in location && { state: location.state }),
    ...("zip" in location && { zip: location.zip }),
    ...("country" in location && { country: location.country }),
    ...("latitude" in location && { latitude: location.latitude }),
    ...("longitude" in location && { longitude: location.longitude }),
    ...("is_selected" in location && { isSelected: location.is_selected })
});
export const advertiserProfileFromService = (profile) => ({
    ...("description" in profile && { description: profile.description }),
    ...("insights_blurb" in profile && { insightsBlurb: profile.insights_blurb }),
    productsServices: profile.products_services,
    competitors: profile.competitors,
    ...("locations" in profile && {
        locations: profile.locations ? profile.locations.map(advertiserLocationFromService) : null
    })
});
//# sourceMappingURL=advertiser.js.map